import { render, staticRenderFns } from "./MpdText.vue?vue&type=template&id=2b389732&"
import script from "./MpdText.vue?vue&type=script&lang=js&"
export * from "./MpdText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports